<template>
  <div>
    <v-row>
      <v-col cols="2">{{ unit.ezObjectId }}</v-col>
      <v-col cols="6">
        <v-form v-model="valid">
          <v-text-field
            :placeholder="$t('page-accommodation.section-manage-units.fields.room-place-name.label')"
            outlined
            dense
            solo-flat
            hide-details
            :disabled="disabled"
            :loading="loading"
            :rules="nameRules"
            v-model="mutatableUnit.name"
            @blur="saveUnit()"
            @keydown="$event.keyCode === 13 ? saveUnit() : ''"
          ></v-text-field>
        </v-form>
      </v-col>
      <v-col cols="2" class="text-center">
        <v-icon :color="unit.calendarFeeds.length ? 'light-green' : 'grey lighten-2'">mdi-checkbox-marked-circle</v-icon>
      </v-col>
      <v-col cols="1" class="text-right">
        <!-- <v-btn small color="primary" outlined @click.stop="openManageCalendarDialog()" :disabled="!rollingBookingRule || !rollingBookingRuleIsFinialised(rollingBookingRule.id)" title="$t('page-accommodation.section-manage-units.fields.calendar-button.title')">
          <v-icon small>mdi-calendar-month</v-icon>
        </v-btn>
        &nbsp; -->

        <v-btn v-if="rollingBookingRule" small color="primary" outlined @click.stop="openManageUnitDialog()" title="$t('page-accommodation.section-manage-units.fields.manage-button.title')"> <v-icon small>mdi-pencil</v-icon> {{ $t('global-terms.manage') }} </v-btn>

        <v-tooltip max-width="225" v-else bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="grey--text text-lighten-1" style="cursor: default;" v-bind="attrs" v-on="on" small color="grey lighten-2" depressed> <v-icon small>mdi-pencil</v-icon> {{ $t('global-terms.manage') }} </v-btn>
          </template>
          <p class="text-center mx-auto mb-0" v-html="$t('page-accommodation.section-manage-units.fields.rules.hint')"></p>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-dialog v-model="manageUnitDialog" width="1000px" persistent>
      <v-card>
        <v-btn fab right absolute x-small class="mt-3" title="Close" @click="closeManageUnitDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-card-title class="headline grey lighten-2 justify-center" primary-title>{{ $t('page-accommodation.section-manage-units.actions.manage.modal-intro', { unit_name: unit.name }) }}</v-card-title>

        <v-card-text style="min-height: 800px;">
          <v-tabs>
            <v-tab>{{ $t('manage-ical-sync.header') }}</v-tab>
            <v-tab-item class="place__v-tab-item">
              <manage-i-cal-sync-tab :unit="unit" :place="place" />
            </v-tab-item>
            <v-tab @click="reloadManualAvailability()">{{ $t('page-unit-manual-booking.header') }}</v-tab>
            <v-tab-item class="place__v-tab-item">
              <manage-manually-tab :unit="unit" :place="place" :key="reloadManualAvailabilityKey" />
            </v-tab-item>
            <v-tab @click="reloadOptions()" v-if="currentUserHasRole('Administrator') || currentUserHasRole('Membership')">
              {{ $t('page-unit-options.header') }}
            </v-tab>
            <v-tab-item class="place__v-tab-item">
              <manage-options-tab :unit="unit" :place="place" :key="reloadOptionsKey" />
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeManageUnitDialog()">{{ $t('global-terms.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="manageCalendarDialog" width="1000px" persistent>
      <v-card>
        <v-btn fab right absolute x-small class="mt-3" title="Close" @click="closeManageCalendarDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-card-title class="headline grey lighten-2 justify-center" primary-title>*Manage Calendar*</v-card-title>

        <v-card-text style="min-height: 800px;">
          <manage-calendar></manage-calendar>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="closeManageCalendarDialog()">{{ $t('global-terms.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ManageManuallyTab from './manage-manually/ManageManuallyTab'
import ManageOptionsTab from './manage-options/ManageOptionsTab'
import ManageICalSyncTab from './manage-ical-sync/ManageICalSyncTab'
import ManageCalendar from './manage-calendar'
import { mapState, mapActions } from 'pinia'
import { useUnitStore, useUserStore, useBookingRuleStore } from '@/stores'
import { clone } from 'ramda'

export default {
  name: 'bookable-unit',
  data () {
    return {
      reloadManualAvailabilityKey: false,
      reloadOptionsKey: false,
      manageUnitDialog: false,
      manageCalendarDialog: false,
      valid: false,
      disabled: false,
      loading: false,
      nameRules: [
        (v) => (v && v.length <= 30) || this.$t('page-accommodation.section-manage-units.fields.room-place-name.validation-length'),
        (v) => !!v || this.$t('page-accommodation.section-manage-units.fields.room-place-name.validation-required'),
      ],
      originalUnit: this.clone(this.unit),
      mutatableUnit: this.clone(this.unit),
    }
  },
  components: {
    ManageManuallyTab,
    ManageOptionsTab,
    ManageICalSyncTab,
    ManageCalendar,
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    place: {
      type: Object,
      required: true,
    },
    rollingBookingRule: {
      type: Object,
    },
  },
  methods: {
    clone,
    ...mapActions(useUnitStore, [
      'httpUpdateUnit',
    ]),
    saveUnit () {
      // if valid and there has been a change
      if (this.valid && this.mutatableUnit.name !== this.originalUnit.name && !this.loading) {
        this.disabled = true
        this.loading = true

        this.httpUpdateUnit({
          unit: this.mutatableUnit,
          args: {
            successMessage: this.$t('page-accommodation.section-manage-units.actions.update-name.toast-success', { unit_name: this.mutatableUnit.name }),
            errorMessage: this.$t('page-accommodation.section-manage-units.actions.update-name.toast-error'),
          },
        }).finally(() => {
          this.loading = false
          this.disabled = false
          this.originalUnit = this.clone(this.mutatableUnit)
        })
      }
    },
    reloadManualAvailability () {
      this.reloadManualAvailabilityKey = !this.reloadManualAvailabilityKey
    },
    reloadOptions () {
      this.reloadOptionsKey = !this.reloadOptionsKey
    },
    openManageUnitDialog () {
      this.manageUnitDialog = true
      this.tagManager.addEvent('Manage Availability', 'Manage Button', this.place.name)
    },
    closeManageUnitDialog () {
      this.manageUnitDialog = false
    },
    openManageCalendarDialog () {
      this.manageCalendarDialog = true
      this.tagManager.addEvent('Manage Calendar', 'Manage Calendar Button', this.place.name)
    },
    closeManageCalendarDialog () {
      this.manageCalendarDialog = false
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useBookingRuleStore, {
      rollingBookingRuleIsFinialised: 'isFinalised',
    }),
  },
}
</script>

<style lang="scss" scoped>
.v-text-field--solo .v-input__slot {
  box-shadow: none;
  -webkit-box-shadow: none;
  display: none;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px;
  -webkit-box-shadow: 0px;
}
</style>
